import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabaseClient';
import { useAuth } from '../lib/AuthProvider';
import { useScreen } from '../lib/useScreen';
import EditorPensamiento from '../components/sala/EditorPensamiento';

const font = "'DM Sans', sans-serif";
const serif = "'DM Serif Display', serif";
const C = { turquesa:'#5dc1b9', mango:'#FDBE02', morado:'#534AB7', moradoClaro:'#AFA9EC' };

export default function MiEspacioPage() {
  const { user, profile, membership } = useAuth();
  const { isMobile } = useScreen();
  const navigate = useNavigate();
  const [pensamientos, setPensamientos] = useState([]);
  const [activo, setActivo] = useState(null);
  const [modoEditor, setModoEditor] = useState(false);

  useEffect(() => {
    if (!user) return;
    supabase.from('pensamientos').select('*').eq('user_id', user.id).eq('visibilidad', 'publico').order('created_at', { ascending: false })
      .then(({ data }) => { setPensamientos(data || []); if (data?.length) setActivo(data[0]); });
  }, [user]);

  const isFree = !membership || membership === 'free_observer';

  return (
    <div style={{ background:'#0a0a0a', minHeight:'100vh', fontFamily:font, color:'#fff' }}>
      {/* Header */}
      <header style={{ display:'flex', alignItems:'center', justifyContent:'space-between', padding:'11px 16px', borderBottom:'0.5px solid rgba(255,255,255,0.06)' }}>
        <button onClick={() => navigate('/sala')} style={{ background:'rgba(83,74,183,0.25)', border:'0.5px solid rgba(175,169,236,0.5)', color:C.moradoClaro, padding:'5px 12px', borderRadius:7, fontSize:12, cursor:'pointer', display:'flex', alignItems:'center', gap:6, fontWeight:500, fontFamily:'inherit' }}>
          ← Regresar a La Sala
        </button>
        <span style={{ fontSize:12, color:'rgba(255,255,255,0.5)' }}>👤 Mi espacio</span>
      </header>

      <div style={{ display:'flex', flexDirection:isMobile?'column':'row', minHeight:'calc(100vh - 50px)' }}>
        {/* Sidebar notas */}
        <aside style={{ width:isMobile?'100%':230, borderRight:isMobile?'none':'0.5px solid rgba(255,255,255,0.06)', borderBottom:isMobile?'0.5px solid rgba(255,255,255,0.06)':'none', padding:'14px 10px', background:'rgba(255,255,255,0.012)', display:'flex', flexDirection:'column', overflowY:'auto', maxHeight:isMobile?'40vh':'none' }}>
          {/* Author card */}
          <div style={{ display:'flex', alignItems:'center', gap:10, padding:'10px 8px', marginBottom:14 }}>
            <div style={{ width:36, height:36, borderRadius:'50%', background:'linear-gradient(135deg, #FDBE02, #1D9E75)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:14, fontWeight:600 }}>
              {(profile?.full_name || 'U')[0]}
            </div>
            <div>
              <p style={{ margin:0, fontSize:13, fontWeight:500 }}>{profile?.full_name || 'Emprendedor'}</p>
              <p style={{ margin:0, fontSize:10, color:'rgba(255,255,255,0.5)' }}>{profile?.business_type || ''} · {profile?.business_stage || ''}</p>
            </div>
          </div>

          {/* Section header */}
          <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', padding:'0 8px', marginBottom:10 }}>
            <p style={{ margin:0, fontSize:10, color:'rgba(255,255,255,0.5)', letterSpacing:1, textTransform:'uppercase' }}>Mis pensamientos · {pensamientos.length}</p>
            <button onClick={() => { setActivo(null); setModoEditor(true); }} style={{ width:24, height:24, background:'rgba(93,193,185,0.12)', border:'0.5px solid rgba(93,193,185,0.3)', borderRadius:6, color:C.turquesa, fontSize:14, cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center' }}>+</button>
          </div>

          {/* Notes list */}
          <div style={{ display:'flex', flexDirection:'column', gap:2, flex:1 }}>
            {pensamientos.map(p => (
              <button key={p.id} onClick={() => { setActivo(p); setModoEditor(false); }} style={{
                padding:'9px 11px', background: activo?.id === p.id ? 'rgba(83,74,183,0.18)' : 'transparent',
                border:0, borderLeft: activo?.id === p.id ? '2px solid #AFA9EC' : '2px solid transparent',
                borderRadius: activo?.id === p.id ? '0 6px 6px 0' : 6,
                textAlign:'left', cursor:'pointer', width:'100%', fontFamily:'inherit', color:'#fff',
              }}>
                <p style={{ margin:0, fontSize:12, fontWeight: activo?.id === p.id ? 500 : 400, color: activo?.id === p.id ? C.moradoClaro : 'rgba(255,255,255,0.75)' }}>{p.titulo}</p>
                <p style={{ margin:'2px 0 0', fontSize:10, color:'rgba(255,255,255,0.35)' }}>{new Date(p.created_at).toLocaleDateString('es')}</p>
              </button>
            ))}
          </div>

          {/* Mis Ideas locked card for free */}
          {isFree && (
            <div style={{ margin:'14px 4px 0', padding:12, background:'linear-gradient(135deg, rgba(175,169,236,0.1), rgba(83,74,183,0.08))', border:'0.5px solid rgba(175,169,236,0.3)', borderRadius:10 }}>
              <p style={{ margin:'0 0 3px', fontSize:10, color:C.moradoClaro, fontWeight:500 }}>🧠 Mis Ideas 🔒</p>
              <p style={{ margin:'0 0 8px', fontSize:11, color:'rgba(255,255,255,0.6)', lineHeight:1.5 }}>Privadas con wikilinks. Disponible en Spark.</p>
              <button onClick={() => navigate('/membresias')} style={{ width:'100%', padding:6, background:'linear-gradient(135deg, #534AB7, #1D9E75)', border:0, color:'#fff', borderRadius:7, fontSize:10, fontWeight:500, cursor:'pointer', fontFamily:'inherit' }}>
                Spark · $139/mes →
              </button>
            </div>
          )}
        </aside>

        {/* Main content */}
        <main style={{ flex:1, padding:isMobile?'16px 12px':'20px 28px', overflowY:'auto' }}>
            {modoEditor ? (
              <EditorPensamiento
                key={activo?.id || 'new'}
                user={user}
                pensamientosUsuario={pensamientos}
                isMobile={isMobile}
                pensamientoExistente={activo}
                onPublicar={(nuevo) => {
                  setPensamientos(prev => activo ? prev.map(p => p.id === nuevo.id ? nuevo : p) : [nuevo, ...prev]);
                  setActivo(nuevo);
                  setModoEditor(false);
                }}
              />
            ) : activo ? (
              <article>
                <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:16 }}>
                  <div>
                    {activo.tags?.length > 0 && (
                      <div style={{ display:'flex', gap:6, marginBottom:8 }}>
                        {activo.tags.map((t, i) => <span key={i} style={{ padding:'3px 9px', background:'rgba(93,193,185,0.12)', color:C.turquesa, borderRadius:999, fontSize:11 }}>{t}</span>)}
                      </div>
                    )}
                    <h1 style={{ fontFamily:serif, fontSize:24, fontWeight:400, margin:0 }}>{activo.titulo}</h1>
                    <p style={{ margin:'4px 0 0', fontSize:11, color:'rgba(255,255,255,0.4)' }}>{new Date(activo.created_at).toLocaleDateString('es')}</p>
                  </div>
                  <div style={{ display:'flex', gap:6 }}>
                    <button onClick={() => setModoEditor(true)} style={{ padding:'8px 14px', background:'rgba(255,255,255,0.06)', border:'0.5px solid rgba(255,255,255,0.1)', borderRadius:8, color:'rgba(255,255,255,0.6)', fontSize:12, cursor:'pointer', fontFamily:'inherit' }}>
                      ✏️ Editar
                    </button>
                    <button onClick={() => {
                      if (!window.confirm('¿Eliminar este pensamiento? Las sinapsis conectadas también se borrarán.')) return;
                      supabase.from('pensamientos').delete().eq('id', activo.id).then(({ error }) => {
                        if (error) { alert('Error al eliminar'); return; }
                        setPensamientos(prev => prev.filter(p => p.id !== activo.id));
                        setActivo(null);
                      });
                    }} style={{ padding:'8px 14px', background:'rgba(235,99,107,0.15)', border:'0.5px solid rgba(235,99,107,0.5)', borderRadius:8, color:'#eb636b', fontSize:12, cursor:'pointer', fontFamily:'inherit' }}>
                      🗑️ Eliminar
                    </button>
                  </div>
                </div>
                <div style={{ fontSize:15, color:'rgba(255,255,255,0.85)', lineHeight:1.8 }} dangerouslySetInnerHTML={{ __html: activo.contenido }} />
              </article>
            ) : (
              <div style={{ textAlign:'center', padding:'4rem 0', maxWidth:420, margin:'0 auto' }}>
                <p style={{ fontSize:32, margin:'0 0 12px' }}>✏️</p>
                <p style={{ fontSize:16, color:'rgba(255,255,255,0.5)', margin:'0 0 16px' }}>Aún no tenés pensamientos.</p>
                <p style={{ fontSize:13, color:'rgba(255,255,255,0.45)', lineHeight:1.7, margin:'0 0 8px', textAlign:'left' }}>
                  Aquí escribes tus pensamientos atómicos. Son públicos y aparecen en la red neuronal de T&D.
                </p>
                <p style={{ fontSize:13, color:'rgba(255,255,255,0.45)', lineHeight:1.7, margin:'0 0 24px', textAlign:'left' }}>
                  También puedes tener Ideas Atómicas privadas, pero necesitas Doer para desbloquearlas.
                </p>
                <button onClick={() => { setActivo(null); setModoEditor(true); }} style={{ padding:'12px 24px', background:C.turquesa, border:'none', borderRadius:50, color:'#fff', fontSize:14, fontWeight:500, cursor:'pointer', fontFamily:'inherit' }}>
                  Escribir el primero
                </button>
              </div>
            )}
          </main>
      </div>

      {/* Floating "Ver la red" button */}
      <button onClick={() => navigate('/sala')} title="Ver la red" style={{
        position:'fixed', top:isMobile?70:16, right:16, width:isMobile?40:32, height:isMobile?40:32,
        borderRadius:'50%', background:'rgba(83,74,183,0.9)', border:'0.5px solid rgba(175,169,236,0.5)',
        color:'#AFA9EC', fontSize:isMobile?18:14, cursor:'pointer', zIndex:50,
        display:'flex', alignItems:'center', justifyContent:'center',
        boxShadow:'0 4px 12px rgba(0,0,0,0.3)',
      }}>🕸️</button>

      <style>{`.wikilink { color:#5dc1b9 !important; background:rgba(93,193,185,0.12); padding:1px 5px; border-radius:4px; text-decoration:underline dotted; font-weight:500; }`}</style>
    </div>
  );
}
